import { create } from "zustand";

import type { IChatState, IMessage } from "./types";

const useChatStore = create<IChatState>(
  (set): IChatState => ({
    error: null,
    isLoading: false,
    isOpen: true,
    messages: [],
    prompt: null,
    setError: (error: string | null): void => {
      set({ error });
    },
    setIsLoading: (isLoading: boolean): void => {
      set({ isLoading });
    },
    setMessages: (newMessages: IMessage[], clearMessages = false): void => {
      set((currentState: IChatState): IChatState => {
        if (clearMessages) {
          return {
            ...currentState,
            messages: newMessages,
          };
        }

        return {
          ...currentState,
          messages: [...currentState.messages, ...newMessages],
        };
      });
    },
    setPrompt: (prompt: string | null): void => {
      set({ prompt });
    },
    toggleIsOpen: (): void => {
      set((state: IChatState): IChatState => {
        return {
          ...state,
          isOpen: !state.isOpen,
        };
      });
    },
  }),
);

export { useChatStore };
export type { IChatState };
